import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { key: 0 }

import { useRouter } from "vue-router";
import { useSession } from "@/stores/session";
import { useSelectOrganisation } from "@/stores/selectOrganisation";
import { useRefreshComponent } from "@/stores/refreshComponent";
import { onMounted, ref } from "vue";
import type { Organisation } from "@/types";
import { AuthAPI, OrganisationAPI } from "@/api";


export default /*@__PURE__*/_defineComponent({
  __name: 'TitleBar',
  setup(__props) {

const router = useRouter();
const {
  currentOrganisation,
  currentTopOrganisation,
  setTopOrganisation,
  initTopOrganisationFromCookie,
  initSubOrganisationFromCookie,
} = useSelectOrganisation();
const { refreshTitleBarKey } = useRefreshComponent();

const { isSuperAdmin } = useSession();

const organisations = ref<Organisation[]>([]);
const topLevelOrganisations = ref<Organisation[]>([]);

const logout = async () => {
  await AuthAPI.logout();
  router.push("/login");
};

onMounted(async () => {
  organisations.value = await OrganisationAPI.fetchAll();
  await initTopOrganisationFromCookie(organisations.value);
  topLevelOrganisations.value = organisations.value.filter(
    (o) => o.organisation_parent_id === null
  );
  await initSubOrganisationFromCookie(organisations.value);
  // when logging in as admin
  if (topLevelOrganisations.value.length <= 1 && !isSuperAdmin.value) {
    await setTopOrganisation(
      topLevelOrganisations.value[0] || organisations.value[0]
    );
  }
});

return (_ctx: any,_cache: any) => {
  const _component_ElOption = _resolveComponent("ElOption")!
  const _component_ElSelect = _resolveComponent("ElSelect")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock("div", {
    key: _unref(refreshTitleBarKey),
    class: "title-bar"
  }, [
    (_unref(isSuperAdmin))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_ElSelect, {
            modelValue: _unref(currentTopOrganisation),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(currentTopOrganisation) ? (currentTopOrganisation).value = $event : null)),
            placeholder: "Select top organisation",
            class: "el-select",
            size: "large",
            clearable: "",
            "value-key": "id",
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_unref(useRefreshComponent)().refreshTitleBar()))
          }, {
            prefix: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode("🏢", -1)
            ])),
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(topLevelOrganisations.value, (organisation) => {
                return (_openBlock(), _createBlock(_component_ElOption, {
                  key: organisation.id,
                  label: organisation.name,
                  value: organisation
                }, null, 8, ["label", "value"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _createVNode(_component_ElSelect, {
        modelValue: _unref(currentOrganisation),
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(currentOrganisation) ? (currentOrganisation).value = $event : null)),
        placeholder: "🏬 Select sub-organisation",
        class: "el-select",
        size: "large",
        clearable: "",
        disabled: !_unref(currentTopOrganisation),
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_unref(useRefreshComponent)().refreshNavigationBar()))
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(organisations.value, (organisation) => {
            return (_openBlock(), _createBlock(_component_ElOption, {
              key: organisation.id,
              label: organisation.name,
              value: organisation.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"])
    ]),
    _createVNode(_component_ElButton, {
      type: "primary",
      icon: "close",
      size: "large",
      onClick: logout
    }, {
      default: _withCtx(() => _cache[5] || (_cache[5] = [
        _createTextVNode(" Uitloggen ", -1)
      ])),
      _: 1,
      __: [5]
    })
  ]))
}
}

})